import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TenantService } from './tenant.service';

@Injectable({ providedIn: 'root' })
export class NutritionFactsService {
  private get base() { return `${this.tenant.apiBaseUrl}/v1/tenant/nutrition-facts`; }
  constructor(private http: HttpClient, private tenant: TenantService) {}
  list(params?: any): Observable<any> { return this.http.get(this.base, { params }); }
  get(id: number): Observable<any> { return this.http.get(`${this.base}/${id}`); }
  create(data: any): Observable<any> { return this.http.post(this.base, data); }
  update(id: number, data: any): Observable<any> { return this.http.put(`${this.base}/${id}`, data); }
  delete(id: number): Observable<any> { return this.http.delete(`${this.base}/${id}`); }
  bulkDelete(ids: number[]): Observable<any> { return this.http.delete(`${this.base}/bulk-destroy`, { body: { ids } }); }

  /**
   * v1.6.1276 — Asana 1216895823946533. Bulk switch "Show In Chart" on/off for one
   * macro across ALL products. Controls whether the macro appears on the meal browsing
   * cards / catalog; separate from the individual product page.
   * PUT /nutrition-facts/{id}/products/show-in-chart  { show_in_chart: boolean }
   */
  bulkShowInChart(nutritionFactId: number, showInChart: boolean): Observable<any> {
    return this.http.put(`${this.base}/${nutritionFactId}/products/show-in-chart`, { show_in_chart: showInChart });
  }
}
